import { render, staticRenderFns } from "./TransactionContentSet.vue?vue&type=template&id=e13a54ae&functional=true&"
import script from "./TransactionContentSet.vue?vue&type=script&lang=ts&"
export * from "./TransactionContentSet.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports